import css from "styled-jsx/css";
import colors from "/styles/colors";
import { ZERO, LAYER_ONE } from "/constants/z-index";
import { MOBILE_QUERY_MAX_WIDTH, MD, XS } from "/constants/vp-sizes";

export const componentStyles = css`
  .title-and-subtitle-component {
    position: relative;
    .title-and-subtitle-content {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: ${LAYER_ONE};

      .title {
        margin-top: 4vh;
        margin-bottom: 0.5vh;
        text-align: center;
        max-width: 80vw;
        font-size: 2.5vw;
        font-weight: bold;

        :global(b) {
          font-weight: 500;
        }
      }

      .subtitle {
        font-size: 1.5vw;
        margin-top: 0;
        font-weight: 300;
        max-width: 80vw;
        text-align: center;
        line-height: 2.4vw;
        margin-bottom: 0;
      }

      &.white-text {
        .title,
        .subtitle {
          color: ${colors["white"]};
        }
      }
    }

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      .title-and-subtitle-component {
        min-height: auto;
        padding: 0px 20px;
        text-align: center;

        .title {
          font-size: 1.575rem;
          margin-bottom: 1.5vh;
          line-height: 1.3;
          font-weight: 300;
        }

        .subtitle {
          font-size: 0.875rem;
          line-height: 1.5;
        }
      }
    }
  }
`;
